<div class="row coreteam-item">
    <div class="col-sm-2">
    
    </div>
    <div class="col-sm-3">
        <img src="/assets/images/coreteam/rebbeca.jpg" width="250px">
    </div>
    <div class="col-sm-7">
    <h4>Rebbeca Kimanai</h4>
    Rebecca Negesa Kimanai holds a diploma in Primary school education (Kyambogo University). She is an authority in mathematics with an experience of over fifteen years as a teacher. She is currently a teacher in Watoto Primary Schools Uganda, Head of Mathematics department ID Raymer Primary School, a Watoto school branch located in BBira Wakiso. She is a strong believer of the learn by doing philosophy.
    </div>
    </div>
